import React, { JSX, useContext } from "react";
import { ProviderNetworkType } from "@app/projects/enumerators";
import {
  ClaimsInsightsDashboardContext,
  ClaimsInsightsProvidersTile,
  ClaimsInsightsSummaryTile,
} from "@app/projects/network-assessment/pci-dashboard/claims-insights";
import { PciDashboardSummaryType } from "@app/projects/network-assessment/pci-dashboard/shared";

export const ClaimsInsightsDashboardDefaultView = (): JSX.Element => {
  const claimsInsightsContext = useContext(ClaimsInsightsDashboardContext);

  return (
    <React.Fragment>
      <div className="row">
        <ClaimsInsightsProvidersTile
          data={claimsInsightsContext.networkProvidersScores}
          effectivenessLoading={claimsInsightsContext.networkProvidersEffectivenessLoading}
          efficiencyLoading={claimsInsightsContext.networkProvidersEfficiencyLoading}
          onDashboardDetailsViewClick={claimsInsightsContext.onDashboardDetailsViewClick}
          providerType={ProviderNetworkType.Network}
        />
        <ClaimsInsightsProvidersTile
          data={claimsInsightsContext.prospectProvidersScores}
          effectivenessLoading={claimsInsightsContext.prospectProvidersEffectivenessLoading}
          efficiencyLoading={claimsInsightsContext.prospectProvidersEfficiencyLoading}
          onDashboardDetailsViewClick={claimsInsightsContext.onDashboardDetailsViewClick}
          providerType={ProviderNetworkType.Prospect}
        />
        <ClaimsInsightsProvidersTile
          data={claimsInsightsContext.marketProvidersScores}
          effectivenessLoading={claimsInsightsContext.marketProvidersEffectivenessLoading}
          efficiencyLoading={claimsInsightsContext.marketProvidersEfficiencyLoading}
          onDashboardDetailsViewClick={claimsInsightsContext.onDashboardDetailsViewClick}
          providerType={ProviderNetworkType.Market}
        />
      </div>
      <div className="row">
        <ClaimsInsightsSummaryTile
          getSummaries={claimsInsightsContext.getSummaries}
          loading={claimsInsightsContext.countySummariesLoading}
          onSummaryDashboardDetailsViewClick={claimsInsightsContext.onSummaryDashboardDetailsViewClick}
          summaryModel={claimsInsightsContext.countySummariesModel}
          summaryType={PciDashboardSummaryType.County}
        />
        <ClaimsInsightsSummaryTile
          getSummaries={claimsInsightsContext.getSummaries}
          loading={claimsInsightsContext.specialtySummariesLoading}
          onSummaryDashboardDetailsViewClick={claimsInsightsContext.onSummaryDashboardDetailsViewClick}
          summaryModel={claimsInsightsContext.specialtySummariesModel}
          summaryType={PciDashboardSummaryType.Specialty}
        />
      </div>
    </React.Fragment>
  );
}

export default ClaimsInsightsDashboardDefaultView;
